export function delay(ms) { // eslint-disable-line import/prefer-default-export
    return new Promise((resolve) => {
        setTimeout(resolve, ms);
    });
}




// WEBPACK FOOTER //
// ./src/util/promise.js